export enum FieldExportType {
  GeoJson = 1,
  KML = 2,
  Csv = 3,
  ShapeFile = 4,
}